<div class='image-wrapper'
     #imageWrapper
     (mousedown)='onMouseDown($event)'
     (mousemove)='onMouseMove($event)'
     (mouseup)='onMouseUp()'
     (mouseleave)='onMouseLeave()'>

  <img #img
       [src]='src'
       [alt]='alt'
       [style.transform]="'scale(' + zoom + ') translate(' + translateX + 'px,' + translateY + 'px)'"
       class='zoomable-img' />

  <button class='reset-button' (click)='resetZoom()' title="{{ 'COMMON.LABELS.RESET_ALT' | translate }}">
    <i class="fa" [ngClass]="zoom > 1 ? 'fa-compress' : 'fa-arrows-alt'"></i>
  </button>
  <button class='download-button' (click)='downloadImage()' title="{{ 'COMMON.LABELS.DOWNLOAD_ALT' | translate }}">
    <i class='fa fa-download'></i>
  </button>
</div>
